export default __webpack_public_path__ + "static/Analyse-tools-c9f546d6ac098bfaed4e14b08176ba2a.png";